module.exports = __webpack_public_path__ + "static/snowboardStore-8d9e8cc285260edb1570a8eb2a91aa5b.png";